// src/pages/Contact/Contact.js
import React from 'react';
import './Contact.css';

const Contact = () => {
  const facebookUrl = 'https://www.facebook.com/profile.php?id=61560818762830';

  // WhatsApp (MX): usa 52 + número sin espacios
  const waNumber = '529994982533';
  const waMessage = encodeURIComponent(
    'Hola Smashes Store 👋 Me interesa un perfume. ¿Me puedes ayudar con disponibilidad y precio?'
  );
  const whatsappUrl = `https://wa.me/${waNumber}?text=${waMessage}`;

  return (
    <div className="contact-page">
      <div className="contact-hero">
        <h1>Contáctanos</h1>
        <p className="contact-subtitle">
          Atención personalizada para ayudarte a elegir <strong>perfumes originales y completos</strong>.
        </p>

        <div className="contact-badges">
          <span className="badge">Perfumes 100% originales</span>
          <span className="badge">Respuesta rápida</span>
          <span className="badge">Atención directa</span>
        </div>
      </div>

      <div className="contact-grid">
        {/* WhatsApp */}
        <div className="contact-card">
          <div className="contact-card-header">
            <div className="contact-icon whatsapp">
              {/* WhatsApp icon */}
              <svg viewBox="0 0 32 32" width="22" height="22" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M19.11 17.21c-.27-.14-1.62-.8-1.87-.89-.25-.09-.44-.14-.62.14-.18.27-.71.89-.87 1.07-.16.18-.32.2-.59.07-.27-.14-1.14-.42-2.17-1.34-.8-.71-1.34-1.6-1.5-1.87-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.44.09-.18.05-.34-.02-.48-.07-.14-.62-1.5-.85-2.06-.22-.53-.44-.46-.62-.46h-.53c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29s.98 2.66 1.12 2.84c.14.18 1.93 2.95 4.68 4.13.65.28 1.16.45 1.55.57.65.2 1.25.17 1.72.1.52-.08 1.62-.66 1.85-1.3.23-.64.23-1.19.16-1.3-.07-.11-.25-.18-.52-.32z"
                />
                <path
                  fill="currentColor"
                  d="M16.02 3C8.85 3 3.02 8.82 3.02 15.98c0 2.56.75 5.02 2.17 7.13L4 29l6.06-1.16c2.02 1.11 4.3 1.69 5.96 1.69 7.16 0 12.98-5.82 12.98-12.98C28.99 8.82 23.18 3 16.02 3zm0 23.45c-1.54 0-3.62-.52-5.36-1.57l-.38-.23-3.59.69.72-3.49-.24-.36a10.43 10.43 0 0 1-1.7-5.71c0-5.76 4.78-10.44 10.55-10.44 5.78 0 10.55 4.68 10.55 10.44 0 5.77-4.77 10.67-10.55 10.67z"
                />
              </svg>
            </div>
            <div>
              <h2>WhatsApp</h2>
              <p className="contact-muted">La forma más rápida para cotizar y apartar.</p>
            </div>
          </div>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn whatsapp-btn"
          >
            Enviar mensaje por WhatsApp
          </a>

          <p className="contact-mini">
            Número: <strong>999 498 2533</strong>
          </p>
        </div>

        {/* Facebook */}
        <div className="contact-card">
          <div className="contact-card-header">
            <div className="contact-icon facebook">
              {/* Facebook icon */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M22.675 0h-21.35c-.734 0-1.325.591-1.325 1.325v21.351c0 .733.591 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.672c0-3.1 1.894-4.788 4.658-4.788 1.325 0 2.462.099 2.794.143v3.24l-1.918.001c-1.504 0-1.794.715-1.794 1.763v2.313h3.587l-.467 3.622h-3.12v9.294h6.116c.733 0 1.324-.591 1.324-1.324v-21.35c0-.735-.591-1.326-1.325-1.326z" />
              </svg>
            </div>
            <div>
              <h2>Facebook</h2>
              <p className="contact-muted">Síguenos y mándanos inbox para dudas o pedidos.</p>
            </div>
          </div>

          <a
            href={facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="contact-btn facebook-btn"
          >
            Ir a Facebook / Enviar inbox
          </a>

          <p className="contact-mini">
            Página: <strong>Smashes Store</strong>
          </p>
        </div>
      </div>

      <div className="contact-footer-note">
        <p>
          <strong>Tip:</strong> si ya sabes qué perfume quieres, mándanos el nombre y la presentación (ml) para
          responderte más rápido.
        </p>
      </div>
    </div>
  );
};

export default Contact;
